import { render, staticRenderFns } from "./BillTotal.vue?vue&type=template&id=06026600"
import script from "./BillTotal.vue?vue&type=script&lang=js"
export * from "./BillTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports